import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María García', 'Carlos López', 'Ana Martínez', 'Pedro Sánchez', 'Laura Fernández', 'Javier Rodríguez', 'Carmen Díaz', 'Diego Moreno', 'Sofía Ruiz', 'Miguel Torres', 'Isabel Navarro', 'Pablo Jiménez', 'Elena Romero', 'Andrés Gil', 'Lucía Serrano'];
const CITIES = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Bilbao', 'Murcia', 'Alicante', 'Córdoba', 'Granada', 'Salamanca', 'Santander', 'Pamplona', 'Toledo'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      // Pick random name and city
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (8-15 seconds)
      const nextInterval = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextInterval);
    };
    // Initial start after a short delay
    const initialTimer = setTimeout(showPopup, 5000);
    return () => {
      clearTimeout(initialTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-394">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 bg-[#FAF7F2] rounded-2xl shadow-xl border border-[#D4A853]/20 p-5 max-w-sm flex items-center space-x-4" data-id="element-395">
          <div className="bg-[#1B4332]/10 p-3 rounded-full flex-shrink-0" data-id="element-396">
            <span className="text-2xl text-[#1B4332]" data-id="element-397">🛒</span>
          </div>
          <div data-id="element-398">
            <p className="text-sm text-[#1B4332] font-medium leading-snug" data-id="element-399">
              <span className="font-bold" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-400">
                {currentData.name}
              </span>{' '}
              de {currentData.city} acaba de comprar el MegaPack
            </p>
            <p className="text-xs text-[#2D5016]/60 mt-1.5 font-medium" data-id="element-401">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}